export const useSanctumService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/sanctum`

  return {
    getCsrfCookie() {
      return fetchJson(
        'GET', `${BASE_URL}/csrf-cookie`, null, null, null, 'include',
      )
    },
  }
}
